import { redirectWithPermissionCheck } from "@/router/index";
import { MAIN_NAVIGATION_ITEMS } from "@/router/constants";
import Interviews from "@/views/interviews/Interviews.vue";
import InterviewDetails from "@/views/interviews/InterviewDetails.vue";
import SelfScheduleInvitation from "@/views/interviews/SelfScheduleInvitation.vue";

const { INTERVIEWS } = MAIN_NAVIGATION_ITEMS;

export const interviewsRouter = [
  {
    path: "/interviews",
    name: INTERVIEWS,
    component: Interviews,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "interviews.view");
    }
  },
  {
    path: "/interviews/:interviewId",
    name: "interviewDetails",
    component: InterviewDetails,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "interviews.view");
    }
  },
  {
    path: "/self-schedule",
    name: "selfScheduleInvite",
    component: SelfScheduleInvitation,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "interviews.view");
    }
  }
];
